module.exports = __webpack_public_path__ + "img/dan-ROJFuWCsfmA-unsplash.b85d459a.jpg";